module.exports = __webpack_public_path__ + "static/media/caret-down.e546de1f.svg";